import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./bite_log_type.js";
//#region src/bite_log_type_helper.ts
var bite_log_type_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(biteLogType) {
	switch (biteLogType) {
		case 22: return "Adyen";
		case 11: return "CardConnect";
		case 28: return "Chase Direct";
		case 5: return "Device Event";
		case 21: return "Eigen";
		case 19: return "Elavon";
		case 4: return "Fatal Error";
		case 17: return "FreedomPay";
		case 15: return "Heartland";
		case 34: return "Transact (Campus Card)";
		case 14: return "Loyalty";
		case 25: return "LRS Table Tracker";
		case 13: return "Kiosk";
		case 8: return "MaitreD";
		case 29: return "Moneris";
		case 23: return "Olo Pay Kiosk";
		case 27: return "PAR Pay";
		case 1: return "Printer";
		case 9: return "Pusher";
		case 0: return "Simple Log";
		case 10: return "Square";
		case 16: return "Stripe";
		case 20: return "Verifone Point Cloud";
		case 24: return "Verifone Point SCA";
		case 12: return "Worldpay";
		case 26: return "Flash";
		case 30: return "JTech Table Tracker";
		case 31: return "Glory";
		case 32: return "Verifone Commander";
		case 33: return "Expo Printer";
	}
}
//#endregion
export { bite_log_type_helper_exports, name };

//# sourceMappingURL=bite_log_type_helper.js.map